export default __webpack_public_path__ + "static/media/logo_dark.d9c17b4c.svg";